<template>
    <section v-if="props.modelValue" class="modal">
        <article class="modal__content">
            <h4 class="modal__title">Detalles de la Aplicación</h4>
            <div class="block-modules">
                <div class="block-module">
                    <h5 class="module-title">Modulos</h5>
                    <div class="container-list">
                        <ul class="module-list">
                            <li>Modulo 1</li>
                            <li>Modulo 2</li>
                            <li>Modulo 3</li>
                        </ul>
                    </div>
                    <button class="add-module-button" @click="openAddModuleModal">Agregar Modulo</button>
                    <ModalModuleApp v-model="showAddModuleModal" />
                </div>
                <div class="block-module">
                    <h5 class="module-title">Permisos</h5>
                    <div class="container-list">
                        <ul class="module-list">
                            <li>Permiso 1</li>
                            <li>Permiso 2</li>
                            <li>Permiso 3</li>
                        </ul>
                    </div>
                    <button class="add-module-button" @click="openAddPermissionModal">Agregar Permiso</button>
                    <ModalPermissionApp v-model="showAddPermissionModal" />
                </div>
            </div>
            <div class="table-users">
                <h5 class="module-title">Empleados con Acceso</h5>
                <input type="text" placeholder="Buscar Usuario..." class="search-input">
                <div class="container-table">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Empleado</th>
                                <th>Modulos</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Karen Carballo Camacho</td>
                                <td>Login - Reportes</td>
                                <td>
                                    <button class="info-button"><i class="bi bi-info-circle-fill"></i></button>
                                    <button class="delete-button"><i class="bi bi-trash-fill"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button class="add-module-button" @click="openAddUserModal">Agregar Usuario</button>
                <ModalAddUserApp v-model="showAddUserModal" />
            </div>
            
            <button class="modal__close" @click="closeModal">&times;</button>
        </article>
    </section>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import ModalModuleApp from './ModalModuleApp.vue';
import ModalPermissionApp from './ModalPermissionApp.vue';
import ModalAddUserApp from './ModalAddUserApp.vue';

const showAddModuleModal = ref(false);
const showAddPermissionModal = ref(false);
const showAddUserModal = ref(false);

const props = defineProps({
    modelValue: Boolean
});
const emit = defineEmits(['update:modelValue']);
const closeModal = () => {
    emit('update:modelValue', false);
};

const openAddModuleModal = () => {
    showAddModuleModal.value = true;
};

const openAddPermissionModal = () => {
    showAddPermissionModal.value = true;
};

const openAddUserModal = () => {
    showAddUserModal.value = true;
};

</script>

<style scoped src="../styles/modalEditApp.css"></style>
